module.exports = __webpack_public_path__ + "kameon-icons.4f96bb4272740fa329c7.eot";


//////////////////
// WEBPACK FOOTER
// C:/GIT/kameon.gdpr/ui/src/assets/fonts/kameon-icons.eot?v=0.1.0
// module id = ../../../../../src/assets/fonts/kameon-icons.eot?v=0.1.0
// module chunks = styles